import { create } from 'zustand';

/**
 * Puente ReferenceTray → ChatPanel. Son hermanos bajo ChatPage y no comparten
 * el composer, así que el tray publica acá una "corrección pendiente" (el motivo
 * del gate anti-repetición convertido en mensaje) y el ChatPanel la consume y la
 * manda sola al chat. Un solo pending a la vez; el ChatPanel lo limpia al enviarlo.
 */
export interface PendingCorrection {
  chatId: string;
  /** Texto ya compuesto: "Iterá #ref8 corrigiendo: ropa, encuadre. <comentario>". */
  text: string;
  /** Assets a adjuntar (normalmente el output que se está corrigiendo). */
  attachmentIds: string[];
}

interface ComposerBridgeState {
  pending: PendingCorrection | null;
  requestSend: (c: PendingCorrection) => void;
  clear: () => void;
}

export const useComposerBridge = create<ComposerBridgeState>((set) => ({
  pending: null,
  requestSend: (c) => set({ pending: c }),
  clear: () => set({ pending: null }),
}));
